import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { ApiService } from 'src/app/Services/api.service';
import { StorageService } from 'src/app/Services/storage.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';

@Component({
  selector: 'app-view-zone',
  templateUrl: './view-zone.component.html',
  styleUrls: ['./view-zone.component.scss']
})
export class ViewZoneComponent implements OnInit {

  public zoneInformation: any[] = [];
  public branchInformation: any[] = [];
  public searchInput: any = new Subject<string>();
  public searchedValue: any = '';
  public serchKey: string = 'zoneName';
  public noDataEnable: boolean = false;

  // Optional filters for zone list payload
  public filterBranchID: string = '';
  public filterTransitMode: string = '';

  // Table configuration (g10-ms-table)
  public cols = [
    { key: '#', display: '#' },
    {
      key: 'zoneName',
      display: 'Zone Name',
      headerConfig: { isDefault: true },
      config: {
        isTruncate: true,
        truncateData: {
          limit: 25,        // approx for >3 words before adding ...
          concatVal: '...'
        }
      }
    },
    { key: 'branchName', display: 'Branch', headerConfig: { isDefault: true } },
    // { key: 'transitMode', display: 'Transit Mode', headerConfig: { isDefault: true } },
    { key: 'nodalCount', display: 'Nodal Count', headerConfig: { isDefault: true } },
    {
      key: 'nodalNames',
      display: 'Nodal Point Name',
      headerConfig: { isDefault: true },
      config: {
        isTruncate: true,
        truncateData: {
          limit: 60,        // characters to show before adding ...
          concatVal: '...'
        }
      }
    },
    {
      key: 'action',
      display: 'Action',
      config: {
        isAction: true,
        actions: [
          { display: 'View', color: 'primary', icon: 'View', class: 'fs-13' },
          { display: 'Edit', color: 'primary', icon: 'Edit', class: 'fs-13' },
          { display: 'Delete', color: 'warn', icon: 'Delete' }
        ]
      }
    }
    
  ];

  public tableShow: boolean = false;
  public showPagination: boolean = false;
  public paginationData = {
    page: 1,
    limit: 10,
    totalPage: 1,
  };

  constructor(
    public api: ApiService,
    public storage: StorageService,
    public router: Router,
    public swal: SweetAlert
  ) { }

  ngOnInit(): void {
    // Load branches first, then load zones so branchName can be resolved
    this.getBranchList();
  }

  getZoneList() {
    const obj = {
      branch: this.filterBranchID,
      
    };
    this.api.transportManagerZoneList(obj).then((res: any) => {
      if (res.status === 'success') {
        const zones = res.data || [];
        // Enrich data for table: branchName, nodalCount, nodalNames, transitMode label
        this.zoneInformation = zones.map((z: any, index: number) => {
          const zoneBranch = z.branch || z.branchID;
          const zoneNodalPoints = Array.isArray(z.nodalPoints) ? z.nodalPoints : (z.nodalPoint || []);
          const zoneIdentifier = z.nodalID || z.zoneID;
          const branchName = this.getBranchName(zoneBranch);
          const nodalCount = zoneNodalPoints.length;
          const nodalNames = this.getNodalNames(zoneNodalPoints).join(', ');
          return {
            index: index + 1,
            ...z,
            zoneID: zoneIdentifier,
            nodalID: zoneIdentifier,
            zoneName: this.toTitleCase(z.zoneName),
            branchName,
            nodalCount,
            nodalNames,
            // transitMode: z.transitMode ? ('' + z.transitMode).charAt(0).toUpperCase() + ('' + z.transitMode).substr(1).toLowerCase() : ''
          };
        });
        this.noDataEnable = true;
        this.tableShow = true;
      } else {
        this.zoneInformation = [];
        this.noDataEnable = true;
        this.tableShow = true;
      }
    }).catch((err) => {
      console.log(err);
      this.swal.swalFunction('error', 'error', 'Failed to load zones.', 3000);
      this.tableShow = true;
    });
  }

  getBranchList() {
    const obj = {
      orgID: this.storage.get('userInfo').orgID
    };
    this.api.transportManagerBranchList(obj).then((res: any) => {
      if (res.status === 'success') {
        this.branchInformation = res.data || [];
        // Once branches are available, load zones so branchName can be mapped
        // if (loadZonesAfter) {
          this.getZoneList();
        // }
      }
    }).catch((err) => {
      console.log(err);
      // if (loadZonesAfter) {
      //   this.getZoneList();
      // }
    });
  }

  getBranchName(id: string): string {
    if (!id || !this.branchInformation || this.branchInformation.length === 0) {
      return '';
    }
    const match = this.branchInformation.find(b => b.branchID === id);
    return match ? match.branchName : '';
  }

  // Return list of nodal point names as array; table component will join & truncate with tooltip
  getNodalNames(nodalPoint: any[]): string[] {
    if (!nodalPoint || nodalPoint.length === 0) {
      return [];
    }
    return nodalPoint.map(n => n.name);
  }

  private toTitleCase(value: string): string {
    if (!value || typeof value !== 'string') {
      return value;
    }
    return value.toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase());
  }

  onActionHandler(e: any) {
    const data = e.data;
    const action = (e.action.display || '').toLowerCase();

    if (action === 'view') {
      if (data && (data.nodalID || data.zoneID)) {
        this.router.navigate(['/organization/transport-manager/information/orgInfo/zone/single-view-zone', data.nodalID || data.zoneID]);
      } else {
        this.swal.swalFunction('error', 'Error', 'Zone ID not found for view.', 3000);
      }
    } else if (action === 'edit') {
      if (data && (data.nodalID || data.zoneID)) {
        this.router.navigate(['/organization/transport-manager/information/orgInfo/zone/edit-zone', data.nodalID || data.zoneID]);
      } else {
        this.swal.swalFunction('error', 'Error', 'Zone ID not found for edit.', 3000);
      }
    } else if (action === 'delete') {
      if (data && (data.nodalID || data.zoneID)) {
        const payload = { nodalID: data.nodalID || data.zoneID };
        this.api.transportManagerZoneDelete(payload).then((res: any) => {
          if (res && res.status === 'success') {
            this.swal.swalFunction('success', 'Deleted', 'Zone deleted successfully.', 2000);
            this.getZoneList();
          }
        }).catch((err) => {
          console.log(err);
          this.swal.swalFunction('error', 'Error', 'Failed to delete zone.', 3000);
        });
      } 
    }
  }

}
